import { inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly httpClient: HttpClient;
  private readonly API_URL = environment.api.base;
  private readonly TOKEN_STORAGE_KEY = environment.auth.tokenKey;
  private readonly REFRESH_TOKEN_STORAGE_KEY = environment.auth.refreshTokenKey;

  constructor() {
    // HttpClient construit à partir de HttpBackend pour éviter les intercepteurs → supprime la boucle circulaire
    const httpBackend = inject(HttpBackend);
    this.httpClient = new HttpClient(httpBackend);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_STORAGE_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_STORAGE_KEY);
  }

  saveTokens(token: string, refreshToken: string): void {
    localStorage.setItem(this.TOKEN_STORAGE_KEY, token);
    localStorage.setItem(this.REFRESH_TOKEN_STORAGE_KEY, refreshToken);
  }

  clearTokens(): void {
    localStorage.removeItem(this.TOKEN_STORAGE_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_STORAGE_KEY);
    localStorage.removeItem('user');
  }

  refreshToken(): Observable<string | null> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      return of(null);
    }

    return this.httpClient
      .post<{ token: string }>(`${this.API_URL}/auth/refresh`, { refreshToken })
      .pipe(
        map((res) => {
          if (res?.token) {
            localStorage.setItem(this.TOKEN_STORAGE_KEY, res.token);
            return res.token;
          }
          return null;
        }),
        catchError(() => of(null))
      );
  }
}
